import type { TopShareholdersProps } from '@/pages/CompanyReport/components/Ownership';
import CalendarOutline from '@simplywallst/ui-core/icons/CalendarOutline';
import {
  ShareholdersDataTable,
  LoudText,
  Owner,
  RoleIcons,
  SecondaryText,
  ChangeText,
  ReportedDateTooltip,
  TooltipTerm,
  TooltipTitle,
  NoDataText,
  LighterText,
} from './styled';
import Tooltip from '@/components/Tooltip';
import { useTracking } from 'react-tracking';

const TopShareholdersTable = ({
  topShareholders,
}: Pick<TopShareholdersProps, 'topShareholders'>) => {
  const tracking = useTracking();

  return (
    <ShareholdersDataTable
      columnWidths="0.3,1,0.3,0.4,0.3,0.3,0.1"
      columnTextAlignments="r,l,r,r,r,l,l"
    >
      <thead>
        <tr>
          <th>Ownership</th>
          <th>Name</th>
          <th>Shares</th>
          <th>Current Value</th>
          <th>
            <Tooltip
              placement={'bottom'}
              title={
                <TooltipTitle>
                  The amount of shares bought or sold by the shareholder between
                  the last two reporting dates
                </TooltipTitle>
              }
              onOpen={() => {
                tracking.trackEvent({
                  modifier: 'jargon',
                  action: 'hover',
                  properties: { term: 'Change %' },
                });
              }}
            >
              <TooltipTerm>Change %</TooltipTerm>
            </Tooltip>
          </th>
          <th>
            <Tooltip
              placement={'bottom'}
              title={
                <TooltipTitle>
                  What percentage this stock makes up of the shareholders total
                  stock portfolio
                </TooltipTitle>
              }
              onOpen={() => {
                tracking.trackEvent({
                  modifier: 'jargon',
                  action: 'hover',
                  properties: { term: 'Portfolio %' },
                });
              }}
            >
              <TooltipTerm>Portfolio %</TooltipTerm>
            </Tooltip>
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {topShareholders.map((shareholder) => (
          <tr key={shareholder.rankSharesHeld}>
            <td>
              <Owner>{shareholder.percentOfSharesOutstanding}%</Owner>
            </td>
            <td>
              <Owner>
                {shareholder.owner.name}
                <RoleIcons
                  boardTitle={shareholder.owner.boardTitle}
                  teamTitle={shareholder.owner.teamTitle}
                />
              </Owner>
            </td>
            <td>
              <SecondaryText>{shareholder.sharesHeldFormat}</SecondaryText>
            </td>
            <td>
              <SecondaryText>{shareholder.holdingValue}</SecondaryText>
            </td>
            <td>
              <ChangeText
                percentSharesChanged={shareholder.percentSharesChanged}
              >
                {shareholder.percentSharesChanged}%
              </ChangeText>
            </td>
            <td>
              {shareholder.percentOfPortfolio === 0 ? (
                <NoDataText>no data</NoDataText>
              ) : (
                <LighterText>{shareholder.percentOfPortfolio}%</LighterText>
              )}
            </td>
            <td>
              <SecondaryText>
                <Tooltip
                  title={
                    <ReportedDateTooltip>
                      Last Reported Holding Date
                      <br />
                      <LoudText>{shareholder.holdingDate}</LoudText>
                    </ReportedDateTooltip>
                  }
                  onOpen={() => {
                    tracking.trackEvent({
                      modifier: 'date',
                      action: 'hover',
                    });
                  }}
                >
                  <CalendarOutline />
                </Tooltip>
              </SecondaryText>
            </td>
          </tr>
        ))}
      </tbody>
    </ShareholdersDataTable>
  );
};
export default TopShareholdersTable;
